import type { ConnectionStatus, InventoryStatus, ItemCondition, ListingStatus, Marketplace, MarketplaceMode, SaleStatus } from "./types";

export const marketplaces: Marketplace[] = ["vinted", "etsy", "ebay", "depop", "shopify"];
export const manualSaleMarketplaces: Marketplace[] = [...marketplaces, "other"];

export const marketplaceLabels: Record<Marketplace, string> = {
  vinted: "Vinted",
  etsy: "Etsy",
  ebay: "eBay",
  depop: "Depop",
  shopify: "Shopify",
  other: "Other"
};

export const marketplaceModes: Record<Marketplace, MarketplaceMode> = {
  vinted: "assisted_manual",
  etsy: "assisted_manual",
  ebay: "assisted_manual",
  depop: "assisted_manual",
  shopify: "assisted_manual",
  other: "tracking_only"
};

export const conditionLabels: Record<ItemCondition, string> = {
  unknown: "Not recorded",
  new: "New",
  new_with_tags: "New with tags",
  new_without_tags: "New without tags",
  like_new: "Like new",
  good: "Good",
  fair: "Fair",
  poor: "Poor"
};

export const inventoryStatusLabels: Record<InventoryStatus, string> = {
  draft: "Draft",
  ready_to_list: "Ready",
  listed: "Listed",
  sold: "Sold",
  archived: "Archived"
};

export const listingStatusLabels: Record<ListingStatus, string> = {
  draft: "Draft",
  ready: "Ready",
  publishing: "Preparing",
  live: "Live",
  sold: "Sold",
  ended: "Ended",
  failed: "Failed",
  delisted: "Delisted",
  archived: "Archived"
};

export const saleStatusLabels: Record<SaleStatus, string> = {
  sold: "Sold",
  paid: "Paid",
  packed: "Packed",
  shipped: "Shipped",
  completed: "Completed",
  refunded: "Refunded",
  cancelled: "Cancelled"
};

export const connectionStatusLabels: Record<ConnectionStatus, string> = {
  connected: "Connected",
  disconnected: "Disconnected",
  error: "Error",
  manual: "Manual"
};
